var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWashingPart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55812 2.36372C9.80221 2.11965 10.1979 2.11965 10.442 2.36372L13.3586 5.28039C13.6027 5.52446 13.6027 5.9202 13.3586 6.16427L10.442 9.08091C10.1979 9.325 9.80221 9.325 9.55812 9.08091L6.64143 6.16427C6.39736 5.9202 6.39736 5.52446 6.64143 5.28039L9.55812 2.36372ZM7.96726 5.72233L10 7.75511L12.0328 5.72233L10 3.68955L7.96726 5.72233Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55812 12.3637C9.80221 12.1196 10.1979 12.1196 10.442 12.3637L13.3586 15.2804C13.6027 15.5245 13.6027 15.9201 13.3586 16.1642L10.442 19.0809C10.1979 19.325 9.80221 19.325 9.55812 19.0809L6.64143 16.1642C6.39736 15.9201 6.39736 15.5245 6.64143 15.2804L9.55812 12.3637ZM7.96726 15.7223L10 17.7551L12.0328 15.7223L10 13.6896L7.96726 15.7223Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5581 7.36372C14.8022 7.11965 15.1979 7.11965 15.4419 7.36372L18.3586 10.2804C18.6027 10.5245 18.6027 10.9202 18.3586 11.1642L15.4419 14.0809C15.1979 14.325 14.8022 14.325 14.5581 14.0809L11.6414 11.1642C11.3974 10.9202 11.3974 10.5245 11.6414 10.2804L14.5581 7.36372ZM12.9673 10.7223L15 12.7551L17.0328 10.7223L15 8.68955L12.9673 10.7223Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5581 7.36372C4.80217 7.11965 5.19791 7.11965 5.44198 7.36372L8.35862 10.2804C8.60271 10.5245 8.60271 10.9202 8.35862 11.1642L5.44198 14.0809C5.19791 14.325 4.80217 14.325 4.5581 14.0809L1.64143 11.1642C1.39736 10.9202 1.39736 10.5245 1.64143 10.2804L4.5581 7.36372ZM2.96726 10.7223L5.00004 12.7551L7.03282 10.7223L5.00004 8.68955L2.96726 10.7223Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingPart);
export default __webpack_public_path__ + "static/media/washingPart.54685326a45a2816a565e65127002a18.svg";
export { ForwardRef as ReactComponent };